import type { ArticlesSearchOrderByInput } from "scmp-app/queries/__generated__/searchArticleResultPaginationQuery.graphql";

export const DefaultSortingOption: {
  text: string;
  value: ArticlesSearchOrderByInput;
} = {
  text: "Sort by Relevance",
  value: {
    field: "RELEVANCE",
  },
};

export const SortingOptions: {
  text: string;
  value: ArticlesSearchOrderByInput;
}[] = [
  { ...DefaultSortingOption },
  {
    text: "Sort by Newest",
    value: {
      direction: "DESC",
      field: "PUBLISHED_DATE",
    },
  },
  {
    text: "Sort by Oldest",
    value: {
      direction: "ASC",
      field: "PUBLISHED_DATE",
    },
  },
];
